var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.422,
    height: 20.876,
    viewBox: "0 0 6.422 20.876",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_69873",
    "data-name": "Raggruppa 69873",
    transform: "translate(-313.758 -147.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8594",
    "data-name": "Tracciato 8594",
    d: "M5.335,2.418H1.351c-.176,0-.353-.007-.528,0A.791.791,0,0,0,0,3.229a.781.781,0,0,0,.857.776c1.233.008,2.466,0,3.7.009a1.092,1.092,0,0,1,.708.129c-.338.3-.656.544-.936.829a.789.789,0,0,0-.094,1.193c.345.363.8.345,1.233-.08Q6.6,4.976,7.711,3.843A.814.814,0,0,0,7.7,2.561Q6.585,1.43,5.452.322A.792.792,0,0,0,4.259.231c-.36.346-.335.8.089,1.237.279.288.577.557.987.949",
    transform: "translate(313.758 155.824) rotate(-90)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8595",
    "data-name": "Tracciato 8595",
    d: "M2.892,4.011H6.746c.878,0,1.258-.235,1.272-.782s-.392-.811-1.3-.811H2.673c.414-.395.713-.663.993-.951.426-.438.453-.888.091-1.236a.792.792,0,0,0-1.195.09Q1.429,1.43.319,2.562A.815.815,0,0,0,.306,3.845Q1.412,4.981,2.548,6.087A.8.8,0,1,0,3.682,4.97c-.272-.278-.572-.527-.86-.789l.07-.17",
    transform: "translate(313.758 168.684) rotate(-90)",
    fill: "#303030"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeight);
export default __webpack_public_path__ + "static/media/height.ee820e287b441193c95736895069d14c.svg";
export { ForwardRef as ReactComponent };